module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_nipa_m2.41fb9386c398fbec9c1dff32d5b5f584.png";